export const pickBy = <T extends Record<string, unknown>>(object?: T): T => {
  let obj = {};
  for (const key in object) {
    if (object[key]) {
      obj = {
        ...obj,
        [key]: object[key],
      };
    }
  }
  return obj as T;
};

export const capitalize = (string: string) => {
  return string
    ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    : "";
};
